import { render, staticRenderFns } from "./detailBill.vue?vue&type=template&id=7754928d&scoped=true&"
import script from "./detailBill.vue?vue&type=script&lang=js&"
export * from "./detailBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7754928d",
  null
  
)

export default component.exports